import React, { Component } from 'react';
import './Colour.css';

const colours = `0	000	#000000	#000000	black
1	001	#0000D7	#0000FF	blue
2	010	#D70000	#FF0000	red
3	011	#D700D7	#FF00FF	magenta
4	100	#00D700	#00FF00	green
5	101	#00D7D7	#00FFFF	cyan
6	110	#D7D700	#FFFF00	yellow
7	111	#D7D7D7	#FFFFFF	white`.split('\n').map(line => {
  let [index, binary, hex, hexLight, name] = line.split('\t');
  return {
    index: parseInt(index, 10),
    binary,
    hex,
    hexLight,
    name,
  };
});

export default class Colour extends Component {
  static get(name) {
    return colours.find(c => c.name === name);
  }

  static get colours() {
    return colours;
  }

  render() {
    const { selected } = this.props;
    return <ul className="Colour">{ colours.map((c, i) => {
      return <li key={`colour-${i}`} className={selected === c.index ? 'selected' : ''} onClick={() => this.props.onChange(c.name) } style={{ background: c.hex }}></li>;
    }) }</ul>;
  }
}



// WEBPACK FOOTER //
// ./src/Colour.js